export enum ClubModel {
  MARKETPLACE = 'MARKETPLACE',
  FOUNDATION = 'FOUNDATION',
  POPUP = 'POPUP',
}
